module.exports = "module.exports = __webpack_public_path__ + &quot;media/images/calendar-3554f6cf1b41636bd4852a9187f7e04b.svg&quot;;"